<script setup>
import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Titre from "@/components/atoms/titre";
import ananas from "@/assets/images/ananas.svg";

const popinRef = ref(null);

const show = () => {
  popinRef.value.show();
};

defineExpose({ show });
</script>

<template>
  <Popin
    ref="popinRef"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    size="lg"
  >
    <div class="u-text-center u-font-15">
      <div class="u-mb-sm">
        <LazyImage
          :src="ananas"
          width="100"
          height="95"
          alt=""
          class="u-inline-block"
        />
      </div>
      <Titre
        tag="h2"
        size="md"
      >
        On s'est déjà vu, non ?
      </Titre>
      <p class="u-mx-lg u-mt-md">
        Il existe déjà un compte Cora utilisant ces informations de contact.
      </p>
      <p class="u-mx-lg u-mt-xs">
        Si vous pensez qu’il ne s’agit pas de vous ou si vous rencontrez des difficultés à vous connecter,
        contactez-nous
      </p>
      <div class="u-inline-flex u-mt-md u-flex-column-reverse@md">
        <Button
          variant="primary"
          radius="full"
          size="md"
          class="u-mr-sm u-mr-none@md"
          to="/connexion"
        >
          Je me connecte
        </Button>
        <Button
          variant="primary"
          outline
          radius="full"
          size="md"
          class="u-ml-md u-ml-none@md u-mb-sm@md"
          to="/infos-et-services/aide/contactez-nous"
        >
          Nous contacter
        </Button>
      </div>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
